export default __webpack_public_path__ + "f1037bbe256782a7842ad16942afbff8.webp";